import './BlockTemplate.css';
import cellSizeEditor from '/src/features/editor/data/cellSizeEditor';
import useBlockSelection from '../../../hook/block/useBlockSelection';
import editorAction from '/src/features/editor/actions/editorAction';
import usePanzone from '../../../hook/useCamera';

function BlockTemplate({x, y, width, height, object_id, data}) {

    const { selectBlock, dropBlock } = useBlockSelection();

    const { deleteBlock, importBlockTemplate } = editorAction();

    const { panzone } = usePanzone();

    const onValidate = () => {
        let form = new FormData();
        form.append("scenario", data.file);
        form.append("x", x - data.coords.min.x);
        form.append("y", y - data.coords.min.y);
        panzone.pause();
        console.log(form);
        importBlockTemplate(object_id, form);
    }

    const style = {
        transform : "translate3d(" + x + "px, " + y + "px, 0)", 
        width : width * cellSizeEditor  + "px",
        height : height * cellSizeEditor + "px"
    }

    return (
        <div className='block template' id={object_id} style={style} onMouseUp={(e) => dropBlock(e, object_id)} onMouseDown={(e) => selectBlock(e, object_id)}>
            <label className="title">TEMPLATE</label>
            <div className="validate btn" onClick={onValidate}></div>
            <div className="cancel btn" onClick={() => deleteBlock(object_id)}></div>
        </div>
    )
}

export default BlockTemplate;